import PropTypes from 'prop-types';
import { FormControl, Grid, MenuItem, Select } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { InfoTooltip } from '../CustomStyles/StyledComponents';
import { ResultStatus } from '../../helpers/reportResultsHelper';
import { AGCReportsPermissions } from '../../helpers/permissionsHelper';
import CreatePDFButton from '../Buttons/CreatePDFButton';
import {AdminRecalcButton} from '../Buttons/AdminButton';
import InputLabel from '@mui/material/InputLabel'
import {agcColours} from '../../helpers/colourHelper'

const ResultsReportsBar = ({ handleReportSelect, reportList, reportId, 
                            calcStatus, permissions, onRecalculated }) => {
    
    // style for the reports bar until we figure out why it doesn't take on the theme
    const ReportSelectSX = {
        width: '95%',pt:0.75,
        '& .MuiSelect-select': {
            fontSize: '.95rem !important',
            padding: '2px 6px !important',
            paddingRight: '30px !important',
        }
    }
    return (
        <Grid container direction="row" sx={{alignItems: "center",}}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
                <FormControl variant="outlined" sx={{ width: '100%', float: 'left' }}>
                    <span>
                        <InputLabel id="report-label"  shrink='true'
                        sx={{color:agcColours.PrussianBlue, "&.Mui-focused": { color: agcColours.AgrecalcPetroleum } }}
                        >Report</InputLabel>
                        <Select sx={ReportSelectSX} displayEmpty value={reportId || ''}
                            onChange={handleReportSelect}
                            autoFocus={true}
                            label="Report" >
                            <MenuItem disabled value=""><em>Change Report...</em></MenuItem>
                            {reportList.map((option) => (
                                <MenuItem
                                    id={option.reportId} key={option.reportId} value={option.reportId}>{option.reportName}</MenuItem>
                            ))}
                        </Select>
                        <InfoTooltip placement="right"
                            title="Tip: If you would like to view a different report please select from this drop-down">
                            <InfoOutlinedIcon color='primary' sx={{ marginLeft: '2px', marginBottom: '5px', verticalAlign: 'bottom' }} fontSize='small' />
                        </InfoTooltip>
                    </span>
                </FormControl>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: 'right' }} >
                <AdminRecalcButton sx={{marginRight: '1em'}} onRecalculated={onRecalculated} />
                {(ResultStatus.isCompleted(calcStatus) && AGCReportsPermissions.canExportPDF(permissions))? 
                <CreatePDFButton referrer={'whole-farm'} /> : ''}
            </Grid>
        </Grid>

    )
}

ResultsReportsBar.propTypes = {
    handleReportSelect: PropTypes.func,
    reportList: PropTypes.arrayOf(PropTypes.object),
    reportId: PropTypes.string,
    calcStatus: PropTypes.number,
    permissions: PropTypes.object,
    onRecalculated: PropTypes.func
};

export default ResultsReportsBar